import { useCallback } from 'react';

type HapticFeedbackType = 'light' | 'medium' | 'heavy' | 'selection' | 'success' | 'warning' | 'error';

/**
 * Hook to provide haptic feedback on mobile devices
 * Uses the Vibration API where supported
 */
export const useHapticFeedback = () => {
  const triggerHaptic = useCallback((type: HapticFeedbackType = 'light') => {
    // Check if vibration API is supported
    if (!('vibrate' in navigator)) {
      return;
    }

    // Define vibration patterns for different feedback types
    const patterns: Record<HapticFeedbackType, number | number[]> = {
      light: 10,
      medium: 20,
      heavy: 30,
      selection: [5, 10],
      success: [10, 50, 10],
      warning: [20, 50, 20],
      error: [50, 100, 50],
    };

    const pattern = patterns[type];

    try {
      if (Array.isArray(pattern)) {
        navigator.vibrate(pattern);
      } else {
        navigator.vibrate(pattern);
      }
    } catch (error) {
      console.error('Haptic feedback error:', error);
    }
  }, []);

  return { triggerHaptic };
};
